module.exports = __webpack_public_path__ + "img/home.0d0dd97f.png";